<template>
  <v-layout>
    <v-dialog v-model="showDialogItem" persistent max-width="600">
      <v-card>
        <v-toolbar color="white" class="elevation-1">
          <v-toolbar-title class="black--text font-weight-light">{{titleComponent}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :disabled="loading" flat color="error" icon round @click.native="closeDialog()">
              <v-icon large color="error">clear</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-form ref="formSupervisor">
            <v-layout justify-space-between wrap px-3 pt-4>
              <v-flex xs12 py-0>
                <v-text-field box v-model="supervisorResposible.name" :rules="inputRules" label="Nome" title="Nome">
                </v-text-field>
              </v-flex>
              <v-flex xs12 py-0>
                <v-text-field v-model="supervisorResposible.email" :rules="emailRules" label="Email" box></v-text-field>
              </v-flex>
              <v-flex xs12 py-0>
                <v-text-field v-model.lazy="supervisorResposible.phone" :rules="inputRules"  return-masked-value mask="(##)####-####"  label="Telefone" box>
                </v-text-field>
              </v-flex>
              <v-flex xs12 py-0>
                <v-text-field v-model.lazy="supervisorResposible.role" :rules="inputRules" label="Função"
                 box></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-3">
          <v-btn :disabled="loading" :loading="loading" block round color="success lighten-1" @click.native="save();">
            Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  export default {

    data() {
      return {
        loading: false,
        showDialogItem: false,
        edit: false,
        supervisorResposible: {}, //fiscal
        emailRules: [
          v => !!v || 'Campo Obrigatório',
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Insira um email válido'
        ],
        inputRules: [
          v => !!v || 'Campo Obrigatório',
        ]
      }
    },
    methods: {
      init() {
        this.edit=false;
        this.supervisorResposible = {};
        this.$refs.formSupervisor.reset();
      },
      save() {
        if (this.$refs.formSupervisor.validate()) {
          this.$emit("savedSupervisor",  this.supervisorResposible);
          this.closeDialog();
        }
      },
      editSupervisor(person) {
        this.init()
        this.edit = true;
        this.supervisorResposible = person;
        this.showDialogItem = true;
      },
      newSupervisor() {
        this.init()
        this.showDialogItem = true;
      },
      closeDialog() {
        this.init();
        this.showDialogItem = false
      }
    },
    computed: {
      titleComponent() {
        return this.edit ? 'Editar Fiscal' : "Novo Fiscal"
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/contract/dialogs/AddNewFiscal.vue